import $ from 'jquery';

class ReviewService {
  constructor() {
    this.baseURL = '/api/v1/reviews';
  }

  fetch(uuid) {
    const url = `${this.baseURL}/${uuid}`;

    return new Promise((resolve, reject) => {
      $.getJSON(url)
        .done(data => {
          resolve(data);
        }).fail(e => {
          reject(e);
        });
    });
  }

  submit(uuid, comment, readability, completed, reviewStartTime) {
    const url = `${this.baseURL}/${uuid}`;

    return new Promise((resolve, reject) => {
      $.ajax({
        type: 'PUT',
        url,
        contentType: 'application/json',
        data: JSON.stringify({
          comment,
          completed,
          readability,
          review_start_time: reviewStartTime,
        }),
      }).done(data => {
        resolve(data);
      }).fail(e => {
        reject(e);
      });
    });
  }

  getScore(uuid) {
    const url = `${this.baseURL}/${uuid}/score`;

    return new Promise((resolve, reject) => {
      $.getJSON(url)
        .done(data => {
          resolve(data);
        }).fail(e => {
          reject(e);
        });
    });
  }

  getCurrentTime() {
    const url = `${this.baseURL}/current_time`;

    return new Promise((resolve, reject) => {
      $.getJSON(url)
        .done(data => {
          resolve(data);
        }).fail(e => {
          reject(e);
        });
    });
  }
}

export default ReviewService;
